<template>
  <div class='search flex'>
    <!-- 左边内容 -->
    <div class="search-content">
      <div class="zi10 w100 search-tags">
        <div class="tags flex aic">
          <div v-for="item in tagList" :key="item.id">
            <p class="fs18 tags-label csp tac" :class="{'tags-active':currTag === item.prop}" @click="changeTag(item)">
              {{item.label}}</p>
          </div>
        </div>
      </div>
      <div class="search-info">
        <div class="flex aic jcb pt25">
          <p class="color_666">共<span class="search-length">{{currTag === 'course'? courseTotal : teacherTotal}}</span>个搜索结果
          </p>
          <div class="flex aic" v-show="currTag === 'course'">
            <p v-for="(val,i) in sortList" :key="i" class="sort-item csp" :class="{'sort-active':order_by === val.prop}" @click="changeSort(val)">{{val.name}}</p>
          </div>
        </div>
        <!-- 课程 -->
        <div v-show="currTag === 'course'">
          <div class="flex aic fww course-box" v-if="courseList.length">
            <course-card v-for="(item,i) in courseList" :key="i" :item="item" image-width="148" image-height="168" width="148" imgKey="bgimg" class="course-box-item" is-custom-label @detail="changeJumpEvent(item)">
              <template #image="{item}">
                <div class="course-box-image">
                  <i class="search-icon audio_icon poa" v-show="item.format_id === 2"></i>
                </div>
              </template>
            </course-card>
          </div>
          <df-page :total="courseTotal" :page-size="courseLimits" :current="courseCurr" @change="changePage"></df-page>
        </div>
        <!-- 教师 -->
        <template v-if="teacherList.length">
          <div v-show="currTag === 'teacher'" class="teacher">
            <div class="teacher-box lh1" v-for="(item,i) in teacherList" :key="i">
              <div class="flex aic w100">
                <img :src="item.bigimg || defaultTeacherImg" alt="" class="teacher-img">
                <div class="flex-1">
                  <div class="flex aic jcb teacher-text">
                    <div class="flex aic">
                      <p class="fs20 teacher-name">{{item.name}}</p>
                      <p class="teacher-zhicheng"><i class="search-icon zhicheng_icon"></i>{{item.zhicheng || '优秀教师'}}</p>
                    </div>
                    <p class="flex aic csp teacher-details" @click="goDetails(item)"><span class="pr5">查看详情</span><i class="search-icon right_arrow pb2"></i></p>
                  </div>
                  <div class="flex aic">
                    <p class="flex aic csp teacher-follow" :class="{'teacher-active':item.is_follow}" @click="changeFollow(item)"><i
                        class="search-icon heart_icon dib mr2 pb2"></i><span>{{item.is_follow ? '已' : ''}}关注</span></p>
                    <p class="flex aic" v-show="item.follow_count"><span class="teacher-dot dib"></span>{{item.follow_count}}粉丝
                    </p>
                  </div>
                </div>
              </div>
              <template v-if="item.course_list && item.course_list.length">
                <p class="fs16 color_666 teacher-course flex aic">TA 的课程<span class="teacher-length pl10">共{{item.course_list.length}}个课程</span>
                </p>
                <div class="flex aic fww teacher-course-content">
                  <course-card v-for="(val,i) in item.course_list.slice(0,6)" :key="i" :item="val" image-width="120" image-height="137" width="120" imgKey="bgimg" class="teacher-course-item"
                    is-custom-label @detail="changeJumpEvent(val)">
                    <template #image="{item}">
                      <div class="course-box-image">
                        <i class="search-icon audio_icon poa" v-show="item.format_id === 2"></i>
                      </div>
                    </template>
                  </course-card>
                </div>
              </template>
            </div>
            <df-page :total="teacherTotal" :page-size="teacherLimits" :current="teacherCurr" @change="changePage"></df-page>
          </div>
        </template>
        <!-- 缺省页 -->
        <template v-if="(currTag === 'course' ? !courseList.length : !teacherList.length)">
          <div class="no-data flex-col aic jcc">
            <div class="search-icon dib" :class="currTag === 'course' ? 'course_icon' : 'teacher_icon'"></div>
            <p class="tac no-data-text">没有找到符合条件的结果</p>
          </div>
          <mine-no-data hidden-text title="近期新课" :image-width="189" :width="189" :image-height="112"></mine-no-data>
        </template>
      </div>
    </div>
    <!-- 右边内容 -->
    <div class="flex-1 list-box">
      <df-list v-for="(item,i) in rankingList" :key="i" :item="item"></df-list>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'HomeSearch',
  data () {
    return {
      defaultTeacherImg: require('@/assets/images/details/default_avatar.png'),
      tagList: [
        { id: 1, label: '课程', prop: 'course', },
        { id: 2, label: '教师', prop: 'teacher', },
      ],
      sortList: [
        { name: '默认', prop: '' },
        { name: '热门', prop: 'hits_total desc' },
        { name: '最新', prop: 'create_time desc' }
      ],
      order_by: '',
      currTag: 'course',
      isShowSort: false,
      courseList: [],
      teacherList: [],
      allTeacherList: [],
      historyList: {},
      courseCurr: 1,
      courseLimits: 25,
      courseTotal: 0,
      teacherCurr: 1,
      teacherLimits: 5,
      teacherTotal: 0,
      recommedList: [],
      keywordList: [],
      boutiqueList: [],
			keyword:'',
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    // keyword () {
    //   return this.$route.query.keyword;
    // },
    rankingList () {
      return [
        { title: '本月热门推荐', icon: 'icon_1', prop: 'course', list: this.recommedList },
        { title: '本月热搜榜', icon: 'icon_2', prop: 'keyword', list: this.keywordList },
        { title: '精品课程畅销榜', icon: 'icon_3', prop: 'course', list: this.boutiqueList }
      ]
    }
  },
  watch: {
		$route(val){
			//路由改变则进行查询
			this.initData();
		},
    teacherList (val) {
      val.forEach(teacher => {
        if (!teacher.course_list || !teacher.course_list.length) {
          this.getTeacherCourse(teacher.id).then(list => teacher.course_list = list).catch(console.log);
        }
      })
    },
  },
  created () {
    this.getRankingList();
    this.initData();
  },
  methods: {
    async initData () {
      this.$emit('set-background-color', '#F5FCFF');
      await this.termSearch();
    },
		async termSearch(){
			//关键词优化
			let { Product, userInfo } = this;
			// 关键词默认获取路由keyword
			let keyword = this.$route.query.keyword || ''
			let params = {
			  keyword:keyword ,
			  ...Product,
			  uid: userInfo.uid,
			};
			if(!keyword){
				// 没有关键词则中止请求
				return
			}
			// 调用关键词优化接口
			let keyList = await this.http.NEWTermSearch(params);
			
			if(keyList.key&&keyList.key.length){
				// 优化后的关键词通过,连接
				this.keyword = keyList.key.join(',');
			}else{
				this.keyword = this.$route.query.keyword
			}
			// 调用课程与教师查询的请求
			this.getInfo();
		},
    // 获取
    async getRankingList () {
      let params = {
        ...this.Product,
        is_web: 1
      };
      await Promise.all([
        this.http.NEWCoursePlayRanking({ format_id: 1, ...params }).then(r => {
          this.recommedList = r.list
        }),
        this.http.NEWKeywordSearch(params).then(r => {
          this.keywordList = r.list
        }),
        this.http.NEWCoursePayRanking(params).then(r => {
          this.boutiqueList = r.list
        }),
      ]).catch(this.$err);
    },
    // 获取搜索内容
    async getInfo () {
      let res = this.historyList[this.keyword];
      if (!res) {
        res = await Promise.all([
          // teacher
          this.getTeacherList(),
          // course
          this.getCourseList()
        ]).then(r => Object.assign({}, ...r));
        this.historyList[this.keyword] = res;
      }
      this.courseTotal = res.courseTotal;
      this.courseList = res.course;
      this.teacherTotal = res.teacherTotal;
      this.allTeacherList = res.teacher;
      this.teacherList = res.teacher.slice(0, 5);
    },
    // 获取老师列表
    async getTeacherList () {
      let { keyword, Product, userInfo } = this;
      let params = {
        keyword: keyword,
        ...Product,
        uid: userInfo.uid,
      };
      let res = await this.http.NEWTeacherSearch(params);
      if (res.list && res.list.length) {
        res.list.forEach(e => {
          e.course_list = [];
        })
      }
      return { teacher: res.list, teacherTotal: res.total };
    },
    // 获取课程
    async getCourseList (isPage = false, isCurr) {
      if (isCurr) {
        this.courseCurr = 1;
      }
      let { keyword, Product, userInfo, courseCurr, courseLimits, order_by } = this;
      let params = {
        keyword: keyword,
        ...Product,
        uid: userInfo.uid,
        curr: courseCurr,
        limits: courseLimits,
        order_by,
      };
      let res = await this.http.NEWCourseSearch(params);
      if (isPage) {
        this.courseList = res.list;
      }
      return { course: res.list, courseTotal: res.total };
    },
    // 获取老师详情
    async getTeacherCourse (id) {
      let res = await this.http.NEWTeacherDetails({ id, ...this.Product, uid: this.userInfo.uid });
      return res.info.course_list;
    },
    // 关注老师
    async changeFollow (item) {
      let { Product, userInfo, teacherCurr } = this;
      if (!userInfo.uid) {
        return this.ShowToast('需要登录才能关注!');
      }
      let params = {
        uid: userInfo.uid,
        teacher_id: item.id,
        ...Product,
      };
      try {
        await this.http.NEWFollowTeacher(params);
        item.follow_count = item.is_follow ? item.follow_count - 1 : item.follow_count + 1;
        item.is_follow = item.is_follow ? 0 : 1;
      } catch (err) {
        console.log(err)
      }
    },
    // 分页
    changePage (value, prop) {
      if (this.currTag === 'course') {
        this.courseCurr = value;
        this.getCourseList(true);
      } else {
        this.teacherCurr = value;
        this.teacherList = this.allTeacherList.slice(((value - 1) * 5), (value * 5));
      }
    },
    // 查看详情
    goDetails (item) {
      this.OpenRouter(`/home/teacher/detail/${item.id}`);
    },
    // 课程跳转
    changeJumpEvent (item) {
      this.OpenRouter(`/home/${item.format_id === 1 ? 'video' : 'audio'}/details/${item.id}/${item.type}`);
    },
    // 切换
    changeTag (item) {
      this.currTag = item.prop;
    },
    // 排序
    changeSort (item) {
      this.order_by = item.prop;
      this.getCourseList(true, true);
    }
  }
}
</script>

<style scoped lang='less'>
@import '../../assets/less/function';

@act-color: #1177ff;

.search-icon {
  .spirit(url(../../assets/images/search_icon.png));
  &.bottom_arrow {
    &:after {
      width: 9px;
      height: 5px;
      background-position: -22px -24px;
    }
  }
  &.bottom_arrow_hover {
    &:after {
      background-position: -34px -24px;
    }
  }
  &.top_arrow {
    &:after {
      width: 9px;
      height: 5px;
      background-position: -45px -24px;
    }
  }
  &.zhicheng_icon {
    padding-right: 4px;
    &:after {
      width: 26px;
      height: 24px;
      background-position: -103px -1px;
    }
  }
  &.right_arrow {
    &:after {
      width: 5px;
      height: 9px;
      background-position: -4px -22px;
    }
  }
  &.right_arrow_hover {
    &:after {
      background-position: -13px -22px;
    }
  }
  &.heart_icon {
    &:after {
      width: 11px;
      height: 11px;
      background-position: -4px -4px;
    }
  }
  &.heart_icon_active {
    &:after {
      background-position: -19px -4px;
    }
  }
  &.heart_icon_hover {
    &:after {
      background-position: -34px -4px;
    }
  }
  &.course_icon {
    &:after {
      width: 104px;
      height: 85px;
      background-position: -2px -61px;
    }
  }
  &.teacher_icon {
    &:after {
      width: 104px;
      height: 85px;
      background-position: -108px -61px;
    }
  }
  &.audio_icon {
    bottom: 6px;
    left: 6px;
    opacity: 0.5;
    &:after {
      width: 25px;
      height: 25px;
      background-position: -77px -2px;
    }
  }
}

.search {
  /deep/ .user-df-title {
    color: #333f4e;
    font-size: 22px;
    padding-bottom: 24px;
  }
  /deep/ .label-box {
    margin: 0;
  }
  .no-data {
    padding: 96px 0;
    &-text {
      padding-top: 18px;
      color: #999fa6;
    }
  }
  &-tags {
    width: 844px;
    position: sticky;
    top: 65px;
    background-color: #f5fcff;
  }
  &-content {
    width: 844px;
  }
  &-info {
    background: #ffffff;
    padding: 0 20px;
    margin-bottom: 42px;
  }
  .sort-item {
    .color_666;
    padding-left: 16px;
    &:hover {
      color: @act-color;
    }
  }
  .sort-active {
    color: @act-color;
  }
  .tags {
    padding: 25px 0 17px;
    &-label {
      margin-right: 22px;
      height: 34px;
      line-height: 34px;
      .color_666;
      &:not(.tags-active):hover {
        color: @act-color;
      }
    }
    &-active {
      width: 83px;
      background: @act-color;
      border-radius: 17px;
      color: #ffffff;
    }
  }
  .course-box {
    padding: 22px 0 35px;
    margin-left: -16px;
    &-item {
      margin: 0 0 25px 16px;
      /deep/ .detail-box {
        font-size: 16px;
        padding: 0;
      }
    }
  }
  .teacher {
    /deep/ .page-box {
      padding: 0;
    }
    padding: 30px 0 40px;
    &-box {
      &:not(:last-child) {
        margin-bottom: 35px;
      }
      border-radius: 8px;
    }
    &-img {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      margin-right: 16px;
    }
    &-text {
      padding-bottom: 18px;
    }
    &-name {
      color: #333f4e;
    }
    &-zhicheng {
      height: 24px;
      line-height: 24px;
      background: #ffe9ed;
      border-radius: 12px;
      color: #ff5776;
      padding-right: 16px;
      margin-left: 23px;
    }
    &-dot {
      width: 3px;
      height: 3px;
      background: #999fa6;
      opacity: 0.7;
      border-radius: 50%;
      margin: 0 5px;
    }
    &-follow {
      .color_666;
      &:not(.teacher-active):hover {
        color: #ff3b5f;
        .heart_icon {
          .search-icon .heart_icon_hover;
        }
      }
    }
    &-active {
      color: #ff5776;
      .heart_icon {
        .search-icon .heart_icon_active;
      }
    }
    &-details {
      color: rgba(102, 111, 122, 0.7);
      &:hover {
        color: @act-color;
        .right_arrow {
          .search-icon .right_arrow_hover;
        }
      }
    }
    &-course {
      padding: 31px 0 18px;
    }
    &-length {
      font-size: 12px;
      color: #999fa6;
    }
    &-course-content{
      margin-left: -16px;
    }
    &-course-item {
      margin-left: 16px;
      /deep/ .detail-box {
        font-size: 14px;
        padding: 0;
      }
    }
  }
  .list-box {
    padding: 24px 0 45px 16px;
  }
  .search-length {
    color: @act-color;
  }
  .color_666 {
    color: #666f7a;
  }
}
</style>
